import { Box } from "@bcc-ui/ui-components";
import * as React from "react";

import style from "./table-footer.scss";

interface Props {
    leftColumn?: React.ReactNode;
    rightColumn?: React.ReactNode;
    className?: string;
}

export const TableFooter = (props: Props) => {
    return (
        <Box
            className={props.className}
            verticalAlignment="Center"
            marginTop="Xs"
            justifyContent="SpaceBetween"
            flexWrap="Wrap"
            gap={"Xxs"}
        >
            <Box className={style.leftColumn}>{props.leftColumn}</Box>
            <Box horizontalAlignment="Right" className={style.rightColumn}>
                {props.rightColumn}
            </Box>
        </Box>
    );
};
